import * as React from "react";
import Svg, { Path, Rect } from "react-native-svg";

function SvgComponent(props) {
  return (
    <Svg
      width={60}
      height={60}
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <Path
        d="M53.72 15.705a5.896 5.896 0 00-4.853-4.852A5.895 5.895 0 0053.719 6a5.895 5.895 0 004.853 4.853 5.896 5.896 0 00-4.853 4.852z"
        fill="#FDB62F"
      />
      <Path
        d="M11.805 25.333a3.717 3.717 0 00-3.06-3.06 3.716 3.716 0 003.06-3.058c.26 1.57 1.49 2.799 3.059 3.059-1.57.26-2.8 1.49-3.06 3.059z"
        fill="#E4A120"
      />
      <Path
        d="M50.868 32.02a2.294 2.294 0 00-3.06-.849l-10.851 4.635a1.537 1.537 0 01-.605.122H22.9a1.53 1.53 0 110-3.06h6.118a4.588 4.588 0 004.589-4.588H20.88a6.953 6.953 0 00-5.422 2.608l-4.795 5.805 5.4 9.896 20.778-4.994a11.04 11.04 0 002.585-.948l10.706-5.484a2.294 2.294 0 00.735-3.143z"
        fill="#F9CFCF"
        stroke="#3762CC"
      />
      <Path
        d="M1.43 41.966a.5.5 0 01.09-.668l6.134-5.133a2.5 2.5 0 013.685.53l5.917 8.876a2.5 2.5 0 01-.364 3.205l-5.912 5.583a.5.5 0 01-.747-.068L5.407 47.71l-3.976-5.744z"
        fill="#4671C6"
        stroke="#3762CC"
      />
      <Path
        d="M13.723 47.402a1.53 1.53 0 100-3.06 1.53 1.53 0 000 3.06z"
        fill="#E0EBFC"
      />
      <Path
        d="M18.974 26.593l-2.723-15.535 32.258-5.942 3.043 16.52-32.578 4.957z"
        fill="#43A4A4"
        stroke="#248787"
        strokeWidth={0.2}
      />
      <Rect
        x={19.047}
        y={12.984}
        width={28}
        height={12}
        rx={0.5}
        transform="rotate(-10.437 19.047 12.984)"
        fill="#BECDE4"
        stroke="#24479E"
      />
      <Path
        d="M38.373 15.78a4.25 4.25 0 11-8.36 1.54 4.25 4.25 0 018.36-1.54z"
        fill="#E0EBFC"
        stroke="#3762CC"
      />
      <Path
        d="M34.903 14.284l-.715.131c.17.195.3.448.393.758l.61-.113-.022.666-.46.085c.052.488-.024.876-.228 1.165-.203.289-.526.474-.968.556l1.92 2.043.009.048-.688.127-2.066-2.205-.096-.506.754-.139c.252-.049.444-.16.575-.332.13-.175.194-.39.19-.647l-1.753.323.021-.666 1.609-.296c-.192-.496-.538-.708-1.039-.639l-.851.157.024-.666 2.802-.516-.021.666z"
        fill="#4671C6"
      />
      <Path
        fill="#6BDDDD"
        stroke="#48BEBE"
        strokeWidth={0.2}
        d="M16.1 10.1h32.8v16.8H16.1z"
      />
      <Rect
        x={18.5}
        y={12.5}
        width={28}
        height={12}
        rx={0.5}
        fill="#E0EBFC"
        stroke="#3762CC"
      />
      <Path
        d="M37 18.75a4.25 4.25 0 11-8.5 0 4.25 4.25 0 018.5 0z"
        fill="#E0EBFC"
        stroke="#3762CC"
      />
      <Path
        d="M33.858 16.651h-.727c.132.223.215.495.25.816H34l-.142.651h-.468c-.037.49-.182.857-.434 1.105-.253.247-.604.37-1.054.37l1.519 2.358V22h-.7l-1.632-2.543-.003-.515h.767c.257-.002.465-.077.625-.222.16-.149.262-.35.305-.602H31l.142-.651h1.635c-.098-.522-.4-.794-.905-.816h-.866l.145-.651H34l-.142.651z"
        fill="#4671C6"
      />
    </Svg>
  );
}

export default SvgComponent;
